import React from "react";
import { motion } from "framer-motion";
import { HiOutlineRocketLaunch } from "react-icons/hi2";

const AIHero = () => {
  return (
    <section className="ai-hero" style={{
      paddingTop: "200px",
      paddingBottom: "120px",
      background: "linear-gradient(135deg, #0a111a 0%, #0f172a 100%)",
      position: "relative",
      overflow: "hidden"
    }}>
      <div className="container-custom">
        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="hero-badge">
              <HiOutlineRocketLaunch /> Next-Gen AI Agents
            </span>
            <h1 className="hero-title">
              Build Smart Systems That <span className="gradient-text">Work, Decide & Scale</span> for You
            </h1>
            <p className="hero-subtitle">
              At Xeer Technology, we design and develop AI Agents that automate workflows, enhance decision-making, and drive efficiency across industries.
            </p>
            <div className="hero-btns">
              <button className="btn-primary">Get Started Now</button>

            </div>
          </motion.div>

          <motion.div
            className="hero-image-wrapper"
          >
            <div className="">
              <img
                src="assets/img/shape/ai_agent_hero_image.jpg"
                alt="AI Agent Illustration"
                className="hero-img"
              />


            </div>
          </motion.div>
        </div>
      </div>

      <style jsx>{`
        .ai-hero {
          padding: 160px 0 100px;
          background: radial-gradient(circle at top right, rgba(59, 130, 246, 0.05), transparent 40%),
                      radial-gradient(circle at bottom left, rgba(59, 130, 246, 0.03), transparent 30%);
        }
        .hero-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
        }
        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          background: rgba(59, 130, 246, 0.1);
          color: #2563eb;
          border-radius: 100px;
          font-size: 0.875rem;
          font-weight: 600;
          margin-bottom: 24px;
        }
        .hero-title {
          font-size: 3.5rem;
          font-weight: 800;
          line-height: 1.1;
          color: #ffffff;
          margin-bottom: 24px;
          letter-spacing: -0.03em;
        }
        .gradient-text {
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .hero-subtitle {
          font-size: 1.25rem;
          color: #64748b;
          margin-bottom: 40px;
          max-width: 540px;
        }
        .hero-btns {
          display: flex;
          gap: 16px;
        }
        .btn-primary {
          padding: 14px 32px;
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          color: white;
          border-radius: 12px;
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.2);
        }
        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 20px 25px -5px rgba(37, 99, 235, 0.3);
        }
        .btn-secondary {
          padding: 14px 32px;
          background: white;
          color: #0f172a;
          border-radius: 12px;
          font-weight: 600;
          border: 1px solid #e2e8f0;
          cursor: pointer;
          transition: all 0.3s;
        }
        .btn-secondary:hover {
          background: #f8fafc;
          border-color: #cbd5e1;
        }
        .hero-image-wrapper {
          position: relative;
        }
       
        .hero-img {
          width: 100%;
          border-radius: 20px;
          display: block;
        }
        .floating-badge {
          position: absolute;
          background: white;
          padding: 12px 20px;
          border-radius: 16px;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 600;
          font-size: 0.875rem;
        }
        .dot {
          width: 8px;
          height: 8px;
          background: #22c55e;
          border-radius: 50%;
        }
        .dot.purple { background: #8b5cf6; }
        .badge-1 { top: 10%; left: -10%; }
        .badge-2 { bottom: 10%; right: -10%; }

        @media (max-width: 1024px) {
          .hero-content {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 40px;
          }
          .hero-subtitle {
            margin-left: auto;
            margin-right: auto;
          }
          .hero-btns {
            justify-content: center;
          }
          .hero-title {
            font-size: 2.75rem;
          }
        }
      `}</style>
    </section>
  );
};

export default AIHero;
